import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TableComponent from '~/components/TableComponent'
import { ManagerQuery } from '~/QueryHooks/ManagerQuery'

const CollectionPointTab: React.FC = () => {
  const { t } = useTranslation()
  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 20
  })

  const {
    data: collectionPointsData,
    isFetching: isFetchingCollectionPoints,
    refetch: fetchCollectionPoints
  } = ManagerQuery.getCollectionPointsIndex({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  })

  useEffect(() => {
    fetchCollectionPoints()
  }, [dataFiltered])

  const tableColumnHeaders = [
    { name: t('EVS Number'), key: 'evsNumber' },
    { name: t('AGIS ID'), key: 'agisId' },
    { name: t('Company name'), key: 'companyName' }
  ]

  const { filtered, rows } = collectionPointsData ? collectionPointsData : { filtered: 0, rows: [] }

  return (
    <TableComponent
      tableColumnHeaders={tableColumnHeaders}
      rows={rows}
      total={filtered}
      isFetchingData={isFetchingCollectionPoints}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      animated
    />
  )
}

export default CollectionPointTab
